import React from "react";
import Header from "../../global/Header";
import Footer from "../../global/Footer";
import { ReactComponent as AcademyLogo } from "../../data/svg/6334Academy.svg";
import { ReactComponent as GroupLogo } from "../../data/svg/6334.svg";
import { ReactComponent as AnalyticsLogo } from "../../data/svg/6A.svg";
import ComingSoon from "../../components/ComingSoon";

const menuItems = [
  { path: "/academy", label: "Home" },
  { path: "/academy/about", label: "About Us" },
  { path: "/academy/services", label: "Services" },
  { path: "/academy/portfolio", label: "Portfolio" },
  { path: "/academy/contact", label: "Contact Us" },
];
const linkLogo = [
  { label: "6334", LinkLogoSvg: GroupLogo, link: "/" },
  {
    label: "Analytics",
    LinkLogoSvg: AnalyticsLogo,
    link: "/analytics",
  },
];

const AcademyHome = () => {
  return (
    <>
      <Header LogoSvg={AcademyLogo} menuItems={menuItems} linkLogo={linkLogo} />
      <ComingSoon backgroundColor="#f8f8ff" color="black" />
      <Footer />
    </>
  );
};

export default AcademyHome;
